import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';

@Component({
    selector: 'app-public-session-created',
    templateUrl: './public-session-created.component.html',
    styleUrls: ['./public-session-created.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicSessionCreatedComponent implements OnInit {
  @Input()
  @ParseJson
  details: UserWallEvent[UserWallEventType.PublicSessionCreated];

  constructor() {}

  ngOnInit(): void {}
}
